module.exports = __webpack_public_path__ + "static/img/planRight4.aa0eb695.png";